import { Stack, Typography } from "@mui/material";
import { getGridStringOperators } from "@mui/x-data-grid-pro";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";
import {
  getActionColumnProperties,
  getDealerApplicationColumnAction,
} from "../DataGrid/ColumnHelpers";
import { getUserLabel } from "../Users/util";
import { formatCurrency } from "@poseidon/utils";
import { getDate } from "@poseidon/firebase/timestamp";

export const getColumnDefinition = () => [
  {
    field: "id",
    headerName: "ID",
    width: 180,
    filterOperators,
  },
  {
    field: "applicationNumber",
    headerName: "Application Number",
    width: 100,
    filterOperators,
    hideable: false,
  },
  {
    field: "createdDate",
    headerName: "Created Date",
    width: 100,
    filterOperators,
    valueGetter: ({ value }) => getDate(value)?.toLocaleDateString() ?? value,
  },
  {
    field: "sailor",
    headerName: "Sailor(s)",
    description: "",
    width: 140,
    filterOperators,
    renderCell: ({ row }) => {
      if (!row.applicants) {
        return;
      }
      const hasJointApplicant = row.applicants.length > 1;
      return (
        <Stack>
          <Typography variant="p">{getUserLabel(row.applicants[0])}</Typography>
          {hasJointApplicant && (
            <Typography variant="p" color="textSecondary">
              {getUserLabel(row.applicants[1])}
            </Typography>
          )}
        </Stack>
      );
    },
  },
  {
    field: "costOfVessel",
    headerName: "Cost of Vessel ",
    width: 100,
    valueGetter: ({ value }) => {
      return formatCurrency(value);
    },
  },
  {
    field: "vessel",
    headerName: "Vessel",
    type: "string",
    width: 150,
    filterOperators,
    renderCell: ({ row }) => {
      if (!row.vessel) {
        return;
      }
      const boatId = row.vessel.id;
      return (
        <Stack>
          <WithDoc
            docRef={`boats/${boatId}`}
            Component={({ data: boat }) => (
              <>
                <Typography variant="p">
                  {boat.make ?? "Make Unknown"}: {boat.model ?? "Model Unknown"}
                </Typography>
                <Typography variant="caption">{boat.type}</Typography>
              </>
            )}
          />
        </Stack>
      );
    },
  },
  {
    field: "boatDocumentation",
    headerName: "Boat Documentation",
    ...getActionColumnProperties("boatDocumentation"),
  },
  {
    field: "invoices",
    headerName: "Invoices",
    ...getActionColumnProperties("invoices"),
  },
  {
    field: "action_survey",
    headerName: "Survey",
    ...getDealerApplicationColumnAction("survey"),
  },
  {
    field: "action_loanDocs",
    headerName: "Loan Docs",
    ...getDealerApplicationColumnAction("loanDocs"),
  },
  {
    field: "completionDate",
    headerName: "Completion Date",
    width: 210,
    filterOperators,
    valueGetter: ({ value }) => getDate(value)?.toLocaleDateString() ?? "TBC",
  },
];

const filterOperators = getGridStringOperators().filter(
  (operator) => operator.value === "equals"
);
// const booleanFilterOperators = getGridBooleanOperators(); //.filter((operator) => operator.value === "equals");
